/**
 * 로그인 때문에 끊긴 목적지를 기억했다가 돌려보낸다.
 *
 * 왜 sessionStorage 인가
 * ---------------------
 * 소셜 로그인은 카카오·네이버 쪽으로 나갔다 돌아온다. 그 사이 화면 상태는
 * 날아가므로 라우터 state 로는 못 지킨다. 반대로 localStorage 는 너무 오래
 * 남아서, 한참 뒤에 앱을 열었는데 옛날에 가려던 화면이 튀어나온다.
 * 세션 동안만 남는 자리가 맞다.
 */
const KEY = 'pending_path'

/** 로그인 화면으로 보내기 직전에 부른다. */
export function rememberPendingPath(path: string): void {
  // 로그인·가입 화면 자신을 적으면 고리가 생긴다
  if (/^\/(login|register|signup|splash)/.test(path)) return

  try {
    sessionStorage.setItem(KEY, path)
  } catch {
    // 사생활 보호 모드 등에서 막힐 수 있다. 못 적으면 그냥 홈으로 간다.
  }
}

/** 로그인 직후 한 번만 꺼내 쓴다. 꺼내면 지운다. */
export function takePendingPath(): string | null {
  try {
    const path = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)
    return path
  } catch {
    return null
  }
}
